export default "__VITE_ASSET__690982d7__"